export default "__VITE_ASSET__BvWmukIt__"